import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { CurrentUser } from 'src/app/core/models/responses/currentUser.model';
import { DialogService } from 'src/app/core/services/dialog.service';
import { environment } from '../../../environments/environment';
import { UploadEndpoint } from '../../core/services/upload.service';
import { UserService } from '../../core/services/user.service';
import { NotificationsDialogComponent } from '../_shared/components/notifications-dialog/notifications-dialog.component';
import { LayoutService } from '../_shared/services/layout.service';

@UntilDestroy()
@Component({
  selector: 'layout-admin',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  host: { class: 'layout' },
  providers: [LayoutService]
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  fullScreen = false;
  toolbarClose = false;
  toolbarBack = false;
  hasActions = false;
  @HostBinding('class.fixedHeight')
  fixedHeight = false;
  hasSidenav = false;
  isLoading = false;
  currentUser: CurrentUser;
  title: string;
  sidenavOpen = false;
  toolbarColor: string;
  uploadProfileImageEndpoint = UploadEndpoint.UserProfileImage;
  supportOpened = false;

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private layoutService: LayoutService, private dialogs: DialogService) {
    this.layoutService.onHeadingChange.pipe(untilDestroyed(this)).subscribe(t => this.title = t);
    this.layoutService.onSidenavToggle.pipe(untilDestroyed(this)).subscribe(open => this.sidenavOpen = open);

    //Handle data on route change
    this.router.events
      .pipe(
        untilDestroyed(this),
        tap(event => {
          if (event instanceof NavigationStart) {
            this.isLoading = true;
          }
          else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
            this.isLoading = false;
            this.sidenavOpen = false;
          }
        }),
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        if (data && data.top) {
          this.toolbarClose = data.top === 'close' || data.top === 'logo';
          this.toolbarBack = data.top === 'back';
          this.toolbarColor = data.top === "logo" ? "primary" : null;
          this.fullScreen = true;
        }
        else {
          this.fullScreen = false;
        }
        this.hasActions = data && data.actions;
        this.fixedHeight = data && data.fixedHeight;
        this.hasSidenav = data && data.sidenav;
      });
  }

  ngOnInit() {
    //Listen to user changes
    this.userService.currentUser.pipe(untilDestroyed(this)).subscribe(u => {
      if (u != null) {
        if (!u.image || u.image.length === 0) {
          u.image = environment.media.publicEndpoint + '/graphics/avatar/na';
        }
        else if (u.image.indexOf('http') !== 0) {
          u.image = environment.media.contentEndpoint + '/thumb/' + u.image + '?width=80&height=80&mode=crop';
        }
        this.currentUser = u;
      }
    });

    //Refresh on load
    this.userService.refreshCurrentUser();
  }

  ngOnDestroy() {}

  openNotifications() {
    this.dialogs.open(NotificationsDialogComponent, true);
  }

  onToolbarClose(usefragment?: boolean) {
    this.layoutService.close(usefragment);
  }

  profileImageUploaded() {
    this.userService.refreshCurrentUser();
  } 

  logout() {
    this.userService.logout().then(() => {
      this.router.navigate(['/auth', 'login']);
    });
  }
}